import { render, staticRenderFns } from "./AuthorizationModal.vue?vue&type=template&id=f9ed0f24&"
import script from "./AuthorizationModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizationModal.vue?vue&type=script&lang=js&"
import style0 from "@/styles/AuthorizationModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports